// Import Bootstrap JS
import * as bootstrap from 'bootstrap';

export default class AjaxModals {
    constructor() {
        this.init();
    }

    async fetchModalContent(url) {
        try {
            const response = await fetch(url, {
                headers: {
                    // This is required for Symfony to recognize the request as AJAX
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });
            const content = await response.text();
            return content;
        } catch (err) {
            console.error(`Error fetching modal content: ${err}`);
            return '<p>Error loading content.</p>';
        }
    }

    showLoading(modalBody) {
        modalBody.innerHTML = `
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>`;
    }

    init() {
        const modalTriggerElements = document.querySelectorAll('[data-modal-href]');
        const modalElement = document.getElementById('ajaxModal');
        const modalInstance = new bootstrap.Modal(modalElement, { keyboard: false });
        const modalBody = document.getElementById('ajaxModalBody');

        modalTriggerElements.forEach((element) => {
            element.addEventListener('click', async (e) => {
                e.preventDefault();

                // Show modal and loading spinner
                this.showLoading(modalBody);
                modalInstance.show();

                // Get the modal URL from the clicked element
                const modalUrl = element.getAttribute('data-modal-href');

                // Fetch content via AJAX
                const content = await this.fetchModalContent(modalUrl);

                // This is a fix to remove the modal #hash from the URL as it prevents re-opening the modal after closing it
                const url = window.location.href.split('#')[0];
                window.history.pushState({ path: url }, '', url);

                // Update modal content
                modalBody.innerHTML = content;

                if (window.LRR && typeof window.LRR.loadModules === 'function') {
                    console.log('Applying modules...');
                    window.LRR.loadModules(modalBody);
                }
            });
        });
    }
}
